import React from 'react'
import { useNavigate } from 'react-router-dom'

function Redirections() {

  const navigate = useNavigate();
  return (
    <div className='initial_page'>
      <div className='links'>
        <button className='admin' onClick={() => navigate("/admin")}>Admin Panel</button>
        
        <button className='teacher' onClick={() => navigate("/teacher")}>Teacher Panel</button>
        
        <button className='student' onClick={() => navigate("/student")}>Student Panel</button>
      </div>
    </div>
  )
}

export default Redirections
